<template>
    <b-form-group :label="theLabel" :label-for="id">
        <b-form-input v-bind="$attrs" v-on="$listeners" :id="id" :state="hasError" :autofocus="autofocus" :value="value"></b-form-input>
        <small v-if="!!help" :class="helpVariant">{{ help }}</small>
    </b-form-group>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        label: {
            type: String,
        },
        id: {
            type: String,
            default: () => `input_${parseInt(Math.random() * 1000000)}`,
        },
        required: {
            type: Boolean,
            default: false,
        },
        error: {},
        autofocus: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [String, Number],
            default: '',
        },
        help: {
            type: String,
            default: '',
        },
        helpVariant: {
            type: String,
            default: 'text-muted',
        },
    },
    computed: {
        theLabel() {
            return this.required ? `${this.label} *` : this.label
        },
        hasError() {
            return !this.error ? null : !this.error
        },
    },
}
</script>
